module.exports = window.evite;